import { Component, h, Element } from '@stencil/core';

@Component({
    tag: 'kdx-share-icons',
    styleUrl: 'kdx-share-icons.scss'
})
export class KdxShareIcons {

    @Element() root: HTMLElement;    
    
    componentDidLoad() {
        const copyIcon = this.root.querySelector('.copy-link');
        if (copyIcon) {
            copyIcon.addEventListener('click', this.clipboardCopy.bind(this));
        }

        this.setShareUrls();
    }

    

    async clipboardCopy(e) {
        e.preventDefault();

        const modal = this.root.querySelector('.copy-modal');
        const a = document.createElement('a');
        a.href = location.href;
        a.textContent = document.title;
        const html = new Blob([a.outerHTML], { type: 'text/html' });
        const plain = new Blob([location.href], { type: 'text/plain' });

        try {
            await navigator.clipboard.write([
                new ClipboardItem({
                    // Promise.resolve required for Safari
                    'text/html': Promise.resolve(html),
                    'text/plain': Promise.resolve(plain),
                }),
            ]);
            
            modal.classList.add('show');
            setTimeout(() => {
                modal.classList.remove('show');
            }, 5000);
        } catch (error) {
            navigator.clipboard.writeText(a.href).then(() => {                
                modal.classList.add('show');
                setTimeout(() => {
                    modal.classList.remove('show');
                }, 5000);
            })
            console.error(error);
        }
    }


    setShareUrls() {
        
        const url = encodeURIComponent(window.location.href);
        const fb = this.root.querySelector('.share-facebook');
        const lk = this.root.querySelector('.share-linkedin');
        const x = this.root.querySelector('.share-x');
        
        if (fb) {
            fb.setAttribute('href', `https://www.facebook.com/sharer/sharer.php?u=${url}`);
        }
        if (lk) {
            lk.setAttribute('href', `https://www.linkedin.com/shareArticle?mini=true&url=${url}`);
        }
        if (x) {
            x.setAttribute('href', `https://x.com/intent/post?url=${url}`);
        }
    }

    render() {
        return (
            <div class="kdx-share-icons">
                <slot/>
            </div>
        );
    }
}
